import styled from "styled-components";

export const OrderPrintWrap = styled.div`
  padding: 20px 30px;
  font-family: 'STSong';
  @media print {
    @page { 
      size: landscape;
      margin-top: 0cm; 
      margin-right: 0mm;
      margin-bottom: 0cm;
      margin-left: 0cm;
    }
  }

  .order-detail--print {
    &--title,
    &--subtitle {
      text-align: center;
    }

    &--title {
      font-size: 24px;
      font-weight: 500;
    }

    &--subtitle {
      font-size: 18px;
      font-weight: 500;
      text-decoration: underline;
    }

    &--order {
      width: 100%;
      & td {
        width: 33%;
        vertical-align: middle;
      }
    }
  }
`